import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CarrierAccountService } from 'app/services/carrier-account.service';
import { AuthWebService } from 'app/services/authweb.service';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';

export interface YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;
  account: any;
}

@Component({
  selector: 'app-enter-otp-popup',
  template: `<div class="modal-dialog" style="none!important;width:380px!important;top:50px!important;">
                <div class="modal-content bgd-c" style="border:none!important;">                   
                   <div class="modal-body" style="border:none!important;">
                     <p class="h6" style="color:white!important;">{{title || 'Confirmation'}}</p>
                     <small class="extra-clr ft-c">{{message}}</small><br/>
                     <small class="text-small" style="color:white!important;font-size:10px!important">{{comment}}</small>          
                     <input #otpInput placeholder="ENTER OTP HERE" style="width: 99%; padding-left: 8px;" />
                   <div style="border:none!important;height:20px!important;margin-top:10px!important;">                     
                     <button type="button" class="btn btn-danger btn-sm pull-right" style="margin-right:4px!important;" (click)="cancel()">{{cancelButtonText || 'No'}}</button>
                     <button type="button" class="btn btn-primary btn-sm pull-right" style="margin-right:4px!important;padding-right:4px!important;" (click)="confirm(otpInput)">{{confirmButtonText || 'Yes'}}</button>
                   </div>
                  </div>
                 </div>
                </div>`,
  styles: [`
   .bgd-c{background:rgb(57, 50,118 )!important;}
   .ft-c{color: rgb(253, 207,76 )!important;}   
 `]
})
export class EnterOtpPopupComponent extends DialogComponent<YesNoModel, boolean> implements YesNoModel {
  title: string;
  message: string;
  comment: string;
  confirmButtonText: string;
  cancelButtonText: string;
  account: any;

  constructor(dialogService: DialogService, private carrierAccountService: CarrierAccountService, private authWebService: AuthWebService, private showModal: PopupService, private toaster: ToastrService) {
    super(dialogService);
  }

  confirm(otpInput) {
    this.carrierAccountService.EnterCarrierAccountLinkOTP(this.account.carrier_person_id, otpInput.value).subscribe(result => {
      if (result == "success") {
        this.result = true;
        this.close();
      }
      else {
        this.result = false;
        this.close();
      }
    });
  }
  cancel() {
    this.result = false;
    this.close();
  }
}
